import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Paper,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  useTheme,
  colors
} from '@mui/material';
import Category from '@mui/icons-material/Category';
import CloseIcon from '@mui/icons-material/Close';
import { NPTReason } from '../types';
import { ElectricalServices } from '@mui/icons-material';

interface NPTReasonFormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: NPTReason) => void;
  selectedNPTReason?: NPTReason;
  isEditMode?: boolean;
}

const AddNewNPTReasonPopUp: React.FC<NPTReasonFormModalProps> = ({ open, onClose, onSubmit, selectedNPTReason, isEditMode }) => {
    const theme = useTheme();
    
    const commonTextFieldStyles = {
      mb: 2,
      backgroundColor: theme.palette.mode === 'light' ? 'white' : theme.palette.background.paper,
      borderRadius: 1,
    };
    const [nptId, setNPTId] = useState<number | ''>('');
    const [nptCode, setNPTCode] = useState('');
    const [nptName, setNPTName] = useState('');
    const [nptDescription, setNPTDescription] = useState('');
    const [nptSortOrder, setNPTSortOrder] = useState<number | ''>('');
    const [nptIsActive, setNPTIsActive] = useState(true);
    useEffect(() => {
        if(isEditMode && selectedNPTReason){
            setNPTId(selectedNPTReason.id);
            setNPTCode(selectedNPTReason.code);
            setNPTName(selectedNPTReason.name);
            setNPTDescription(selectedNPTReason.description);
            setNPTSortOrder(selectedNPTReason.sortOrder);
            setNPTIsActive(selectedNPTReason.isActive);
        }
        else{
            setNPTId(0);
            setNPTCode('');
            setNPTName('');
            setNPTDescription('');
            setNPTSortOrder('');
            setNPTIsActive(true);
        }
    },[isEditMode, selectedNPTReason]);

    const handleSubmit = () => {
        const payload: NPTReason = {
            id: Number(nptId),
            code: nptCode,
            name: nptName,
            description: nptDescription,
            sortOrder: Number(nptSortOrder),
            isActive: nptIsActive,
            isDeleted: false
        };
        onSubmit(payload);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
              <DialogTitle>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Typography variant="h6">
                    <Category /> Add New NPT Reason
                  </Typography>
                  <IconButton onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                    <Paper elevation={0} sx={{ p: 2, backgroundColor: 'transparent', borderRadius: 2 }}>
                      <Grid container spacing={3}>
                        {/* Left Column */}
                        <Grid item xs={12} md={6}>
                          <TextField fullWidth 
                            label="NPT Reason Code" 
                            variant="outlined" 
                            sx={commonTextFieldStyles} 
                            value = {nptCode}
                            onChange={(e) => setNPTCode(e.target.value)}
                            />
                          <TextField fullWidth 
                            label="NPT Reason Description" 
                            variant="outlined" 
                            sx={commonTextFieldStyles}
                            value={nptDescription}
                            onChange={(e) => setNPTDescription(e.target.value)} 
                            />
                          
                        </Grid>
            
                        {/* Right Column */}
                        <Grid item xs={12} md={6}>
                            <TextField fullWidth 
                              label="NPT Reason Name" 
                              variant="outlined" 
                              sx={commonTextFieldStyles}
                              value={nptName}
                              onChange={(e) => setNPTName(e.target.value)} 
                              />
                            <TextField fullWidth 
                            label="Sort Order" 
                            type="number" 
                            variant="outlined" 
                            sx={commonTextFieldStyles}
                            value={nptSortOrder}
                            onChange={(e) => setNPTSortOrder(Number(e.target.value))} 
                            />
                        </Grid>
            
                        {/* Checkbox */}
                        <Grid item xs={12}>
                          <FormControlLabel
                              control={
                              <Checkbox
                              checked={nptIsActive}
                              onChange={(e) => setNPTIsActive(e.target.checked)}
                              />
                              }
                          label="Active NPT Reason"
                          sx={{ mb: 2 }}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </DialogContent>
            
                  <DialogActions>
                          <Button
                            variant="contained"
                            sx={{
                                background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                                        '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' },
                                        mb:2
                                }}
                            onClick={handleSubmit}
                          >
                            {isEditMode ? 'Update NPT Reason' : 'Create NPT Reason'}
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                                background: 'linear-gradient(135deg, #667eea 0%, #4c5fd7 100%)',
                                        '&:hover': { background: 'linear-gradient(135deg, #4c5fd7 0%, #c2410c 100%)' },
                                        mb:2
                                }}
                            onClick={onClose}
                          >
                            Cancel
                          </Button>
                        </DialogActions>
        </Dialog>
    );
};

export default AddNewNPTReasonPopUp;
